module.exports = __webpack_public_path__ + "media/ko_kr_s1_DongMin.9d9fdce0.mp3";